export const handleTileClick = (e) => {
  const tileEl = e.target.closest('.js-tile')
  if (tileEl) {
    const tileLinkEl = tileEl.querySelector('.js-tile-link')
    if (tileLinkEl) {
      // Allow user to open link in new tab if ctrl/cmd button pressed
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault()
        window.open(tileLinkEl.getAttribute('href'), '_blank')
      } else {
        tileLinkEl.click()
      }
    }
  }
}
